export default {
  "content": "<g clip-path=\"url(#a)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.813 5.587L3.8 6.847H.233A4.213 4.213 0 010 5.473a4.073 4.073 0 014-4.14A3.913 3.913 0 018 5.08a3.913 3.913 0 014-3.747 4.073 4.073 0 014 4.14c0 .472-.078.941-.233 1.387H9.633a.667.667 0 00-.566.327L7.987 8.98 5.9 5.647a.667.667 0 00-1.087-.06zm3.747 5L10 8.18h5.02a3.898 3.898 0 01-.227.253L8.24 15.227a.327.327 0 01-.48 0L1.207 8.433A4.094 4.094 0 01.98 8.18h3.167a.667.667 0 00.52-.247l.6-.786 2.16 3.453a.667.667 0 001.133-.013z\" fill=\"#fff\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 -6.5 16 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};